<div class="error {{ getCssClass() }}" *ngIf="getValidationErrors().length || errors.length">
  <ul>
    <li *ngFor="let error of getValidationErrors(); let i = index">
      <div>
        {{ error }}
        <ion-icon *ngIf="i === 0" name="wg-error"></ion-icon>
      </div>
    </li>
    <li *ngFor="let error of errors">{{ error }}</li>
  </ul>
</div>
